module.exports = __webpack_public_path__ + "img/cotizacion_tabla.f9fc85d4.jpg";